import logo from "./../Image/kiyo_logo.png";
import { motion } from "framer-motion";

export function Logo() {
  return (
    <motion.div
      className="flex flex-col items-center justify-center space-y-4"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
      <img
        src={logo}
        alt="Company Logo"
        width={100}
        height={100}
        className="rounded-full"
      />

      {/* <span className="text-3xl font-semibold text-[#D60033] uppercase">
        Kiyo International
      </span> */}
    </motion.div>
  );
}
